import { render, staticRenderFns } from "./IncidentCauses.vue?vue&type=template&id=6ee5ca1c&scoped=true"
import script from "./IncidentCauses.vue?vue&type=script&lang=js"
export * from "./IncidentCauses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee5ca1c",
  null
  
)

export default component.exports